import {
    Dialog,
    Box,
    Divider,
    ListItemAvatar,
    ListItemText,
    ListItem
} from '@mui/material';
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as FAQIcon } from '../assets/faq.svg';
/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";

function FAQ() {
    const [open, setOpen] = useState(false);
    const [textAccordion, setTextAccordion] = useState([false]);
    const [accordions, setAccordions] = useState([
        {
            id: 0,
            title: '예약수업은 어떻게 취소할 수 있나요?',
            content: `예약수업 취소는, 내수업 페이지의 내수업 탭에서 예약취소 버튼 클릭 시 가능합니다.
단, 당일 수업 취소는 불가능합니다. (수업 시작 1일 전까지 취소 가능)`,
            show: false,
        },
        {
            id: 1,
            title: '쿠폰은 어떻게 환불할 수 있나요?',
            content: `환불 신청은 미사용 쿠폰만 가능하며, 쿠폰 시작일로부터 7일 이내에만 가능합니다.
단, 1회권은 유효기간이 7일이므로 구매 후 3일 이내에만 환불 신청 가능합니다.
구매 쿠폰을 단 1회라도 사용했을 시, 남은 쿠폰은 환불 불가합니다.`,
            show: false,
        },
        {
            id: 2,
            title: '불가피한 사정으로 수업에 참석하지 못했습니다. 쿠폰 반환이 가능한가요?',
            content: `불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환`,
            show: false,
        },
        {
            id: 3,
            title: '수업 예약하는 방법을 알고 싶습니다.',
            content: `1. 원하는 센터를 선택합니다.
2. 달력에서 수업을 듣고 싶은 날짜를 선택합니다(센터별로 수업시간은 상이함).
3. 달력 하단 리스트에서 원하는 수업을 고릅니다.
4. 예약 팝업에서 OK 버튼을 누르면 예약이 됩니다.

예약확인은 내수업 페이지의 내수업 탭에서 확인 가능합니다.`,
            show: false,
        },
//         {
//             id: 4,
//             title: '',
//             content: `불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
// 불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
// 반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환`,
//             show: false,
//         },
    ]);

    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };

    const openText = (id) => {
        // setTextAccordion((state) => {
        //     // const idx = accordions.findIndex(el => el.id === id);
        //     state[id] = !state[id];
        //     let newState = state;
        //     console.log(newState)
        //     return [...state, newState];
        // })
        // setAccordions((state) => {
        //     state[id].show = !state[id].show
        //     let newState = state;
        //     console.log(state)
        //     return [...newState]
            
        // })

        const idx = accordions.findIndex(el => el.id === id);
        const show = !accordions[id].show;
        
        setAccordions((state) => {
            let newState = state;
            newState[id].show = show;
            return [...newState];
        })
    }
    const stretchedText = css`
    max-height: fit-content;
    height: fit-content;
    display: block;
    font-size: 14px;
    white-space: pre-wrap;
    margin-bottom: 10px;
    `
    // const stretchedBox = css`
    // box-shadow: 1px 1px 4px gray;
    // margin-bottom: 10px;
    // `

    return (
        <>
            <Dialog fullScreen open={open} onClose={closeClick}>
                <Box>
                    <Box
                        sx={{
                            width: '90%',
                            textAlign: 'left',
                            padding: '30px 0 10px 10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }}>
                        <img src='/img/back_button_black.png' onClick={closeClick} />
                        <Box
                            sx={{
                                width: '100%',
                                margin: '25px 0 0 10px',
                                fontSize: '22px',
                            }}>
                            <Box>
                                FAQ
                            </Box>
                        </Box>
                    </Box>
                    <Divider />
                    <Box margin='20px'>
                        {accordions.map((item, index) => {
                            return (
                                <Box
                                    onClick={() => openText(item.id, item.show)}
                                    key={index}
                                    sx={{
                                        // padding: '10px'
                                    }}
                                    // css={
                                    //     accordions[index].show === true ? stretchedBox : null
                                    // }
                                    >
                                    <Box
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                            padding: '10px 0'
                                        }}
                                        >
                                        {item.title}
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'none',
                                            // overflow: 'hidden',

                                        }}
                                        css={
                                            accordions[index].show === true ? stretchedText : null
                                        }>
                                        {item.content}
                                    </Box>
                                    <Divider />
                                </Box>
                                
                            )
                        })}

                        {/* <Box
                            onClick={openText}>
                            <Box
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: '16px'
                                }}>
                                예약에 사용된 쿠폰은 어떻게 취소할 수 있나요?
                            </Box>
                            <Box
                                sx={{
                                    display: 'none'
                                }}
                                css={
                                    openAccordion === true ? stretchedText : null
                                }>
                                예약수업 취소는, 내수업 페이지의 내수업 탭에서 예약취소
                                버튼 클릭 시 가능합니다.
                                <br></br>
                                단, 당일 수업 취소는 불가능합니다. (수업 48시간 전까지
                                취소 가능)
                            </Box>
                        </Box>
                        <Divider variant='middle' />
                        <Box
                            onClick={openText}>
                            <Box
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: '16px'
                                }}>
                                쿠폰은 어떻게 환불할 수 있나요?
                            </Box>
                            <Box
                                sx={{
                                    display: 'none'
                                }}
                                css={
                                    openAccordion === true ? stretchedText : null
                                }>
                                환불 신청은 쿠폰 구매 후 미사용 쿠폰에 한해서만 5일 이내에 가능합니다.
                                <br></br>
                                단, 1회권은 유효기간이 7일이므로 구매 후 3일 이내에만 환불 신청 가능합니다.
                                <br></br>
                                구매 쿠폰을 단 1회라도 사용했을 시, 남은 쿠폰은 환불 불가합니다.
                            </Box>
                        </Box>
                        <Divider variant='middle' />
                        <Box
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '16px'
                            }}>
                            불가피한 사정으로 수업에 참석하지 못했습니다. 쿠폰 반환이 가능한가요?
                        </Box>
                        <Box>
                            불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
                            <br></br>
                            &middot; 불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
                            <br></br>
                      &middot; 반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환
                        </Box> */}
                    </Box>
                </Box>
            </Dialog>
            <ListItem
                sx={{ textAlign: "center" }}
                onClick={openClick}
            >
                <ListItemAvatar>
                    <FAQIcon width='24px' height='24px' />
                </ListItemAvatar>
                <ListItemText sx={{ textAlign: "left" }}>
                    FAQ
                </ListItemText>
                <ListItemAvatar>
                    <ArrowRightIcon />
                </ListItemAvatar>
            </ListItem>
        </>
    )
}

export default FAQ;